import { createSlice } from '@reduxjs/toolkit';
import { UpdateProfile, GetProfileById, GetCurrentProfile, GetUsernameMention, GetHashtag } from '../services/ProfileService';

export const ProfileSlice = createSlice({
  name: 'dropdown',
  initialState: {
    addProfile: '',
    ProfileList: [],
    getProfile: '',
    updateProfile: '',
    mentions: {},
    hashtag: {}
  },
  reducers: {
    addProfile: (state, action) => {
      state.addProfile = [action.payload];
    },
    ProfileList: (state, action) => {
      state.ProfileList = [action.payload];
    },
    getProfile: (state, action) => {
      state.getProfile = action.payload;
    },
    updateProfileFun: (state, action) => {
      state.updateProfile = [action.payload];
    },
    setCurrentProfile: (state, action) => {
      state.currentProfile = action.payload;
    },
  },
});

export const updateProfileList = (payload, userId, type) => async () => {
  return UpdateProfile(payload, userId, type)
};

export const getProfileByuserId = (data) => async (dispatch) => {
  GetProfileById(data).then((response) => {
    dispatch(getProfile(response.data?.data));
  });
};

export const getProfileByuserName = () => async (dispatch) => {
  return GetCurrentProfile().then((response) => {
    dispatch(setCurrentProfile(response.data?.data));
    return response;
  }). catch((err) => {
    return err;
  });
};

export const getUsernameMentionList = (usernameValue) => async () => {
  return GetUsernameMention(usernameValue).then((response) => {
    return response.data;
  });
};

export const getHashtagList = () => async () => {
  return GetHashtag().then((response) => {
    return response.data;
  });
};

export const { ProfileList, addProfile, updateProfileFun, getProfile, setCurrentProfile } =
  ProfileSlice.actions;
export default ProfileSlice.reducer;
